module.exports = __webpack_public_path__ + "img/tv-03.393e7767.svg";